import styled from 'styled-components'

export const FormLabel = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: var(--color-title);
`
